import { useMutation, useQueryClient } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { toast } from 'sonner';

interface CancelDealParams {
  dealId: string;
  reason: string;
  cancelledBy: string;
  cancelPayments: boolean;
  cancelledAt?: Date;
}

export const useCancelDeal = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ dealId, reason, cancelledBy, cancelPayments, cancelledAt }: CancelDealParams) => {
      if (cancelPayments) {
        // Use RPC that cancels deal + pending payments
        const { data, error } = await supabase.rpc('cancel_deal_with_payments', {
          p_deal_id: dealId,
          p_reason: reason,
          p_cancelled_by: cancelledBy
        });

        if (error) throw error;
        return data;
      } else {
        // Only cancel the deal, keep payments as-is
        const { data, error } = await supabase
          .from('deals')
          .update({
            deal_status: 'cancelled',
            cancelled_at: (cancelledAt || new Date()).toISOString(),
            cancellation_reason: reason
          })
          .eq('id', dealId)
          .select()
          .single();

        if (error) throw error;
        return data;
      }
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['deal'] });
      queryClient.invalidateQueries({ queryKey: ['deals'] });
      queryClient.invalidateQueries({ queryKey: ['payments'] });
      toast.success('Contrato cancelado com sucesso');
    },
    onError: (error: Error) => {
      console.error('Error cancelling deal:', error);
      toast.error('Erro ao cancelar contrato: ' + error.message);
    }
  });
};

